<!-- backend/src/components/Cards/CardFormullerSettings.svelte -->
<script>
  import { onMount, afterUpdate } from 'svelte';
  import { gostergeList, formulAdd, formulUpdate } from '../../Api.svelte';
  import { formullerStore, selectedFormul, isFormulEditing, selectedGostergeDegerSayisi } from "../../stores/stores";
  import { getGostergeData } from '../../mw/check';


  let formul = '';
  let _id = null;
  let formulEditing = false;
  let gostergeler = [];
  let selectedFormulGosterge = '';
  let degiskenler = [];
  let clickedVariables = [];
  let history = [];

  let formuller = [];
  selectedFormul.subscribe(sformul => {
    if (sformul) {
      _id = sformul._id;
      selectedFormulGosterge = sformul.gosterge_id;
      formul = sformul.formul;
      degiskenler = [...sformul.degiskenler];
      clickedVariables = new Array(degiskenler.length).fill(false);
      history = [];
    }
  });

  isFormulEditing.subscribe(sformul => {
    formulEditing = sformul;
    if (formulEditing) {
      formul = ''; // Sadece formul düzenleme modunda değilse formul inputunu boşalt
    }

  });

  formullerStore.subscribe(sformul => {
    formuller = sformul;
  });

  async function submitForm() {
    if (!degiskenler || degiskenler.length === 0) {
      console.error('Değişkenler dizisi tanımsız veya boş.');
      return;
    }

    if (formulEditing) {
      await updateFormul();
    } else {
      await addFormul();
    }
  }

  async function addFormul() {
    const result = await formulAdd(selectedFormulGosterge, formul, degiskenler);
    if (result) {
      resetForm();
      formullerStore.set(result);
    } else {
      console.error('Gösterge ekleme başarısız.');
    }
  }

  async function updateFormul() {
    const result = await formulUpdate(_id, selectedFormulGosterge, formul, degiskenler);
    if (result) {
      formullerStore.set(result);
      resetForm();
    } else {
      console.error('Gösterge güncelleme başarısız.');
    }
  }

  function resetForm() {
    _id = null;
    selectedFormulGosterge = '';
    formul = '';
    degiskenler = [];
    clickedVariables = [];
    history = [];
    isFormulEditing.set(false);
    selectedFormul.set(null);
  }
  if (selectedFormulGosterge) {
    updateSelectedGostergeDegerSayisi();
  }
  function updateSelectedGostergeDegerSayisi() {
    // console.log(selectedFormulGosterge);
    const gosterge = gostergeler.find(g => g._id === selectedFormulGosterge);
    // console.log(gosterge);
    if (selectedFormulGosterge) {
    // console.log(gosterge.deger_sayisi);
      
      selectedGostergeDegerSayisi.set(gosterge.deger_sayisi);
    } else {
      selectedGostergeDegerSayisi.set('');
    }
  }

  function watchSelectedGosterge(newValue, oldValue) {
    updateSelectedGostergeDegerSayisi();
  }

  afterUpdate(() => {
    watchSelectedGosterge();
}, [selectedFormulGosterge]);


  onMount(async () => {
    gostergeler = await gostergeList();
    gostergeler = await getGostergeData(gostergeler);
  });

  function addToFormul(value, index = null) {
    history.push({ formul, clickedVariables: [...clickedVariables] }); // Add current formula and clickedVariables to history before modifying
    formul += value;
    if (index !== null && degiskenler && degiskenler.length > index) {
      clickedVariables[index] = true;
    }
  }

  function undoFormul() {
    if (history.length > 0) {
      const lastState = history.pop(); 
      formul = lastState.formul;
      clickedVariables = lastState.clickedVariables;
    }
  }

  function clearFormul() {
    history.push({ formul, clickedVariables: [...clickedVariables] }); // Add current formula and clickedVariables to history before clearing
    formul = '';
    clickedVariables = [];
  }
</script>

<div class="relative flex flex-col min-w-0 break-words w-full mb-6 shadow-lg rounded bg-white">
  <div class="rounded-t mb-0 px-4 py-3 border-0">
    <div class="flex flex-wrap items-center">
      <div class="relative w-full px-4 max-w-full flex-grow flex-1">
        <h3 class="font-semibold text-lg text-blueGray-700">
          {formulEditing ? 'Formül Düzenle' : 'Formül Ekle'}
          <span class="text-red-500 text-xs">***Formül ekleyebilmeniz için Değişken Sayınızın 1 den büyük olması gerekiyor.</span>
        </h3>
        <span class="text-red-500 text-xs">***Göstergede Değişken Sayısı 1 den büyük olanlar listelenmiştir.</span>
      </div>
    </div>
  </div>
  <div class="block w-full overflow-x-auto">
    <form on:submit|preventDefault={submitForm}>
      <div class="px-6 py-4">
        <div class="flex flex-wrap -mx-4">
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Gösterge
              </label>
              <div class="relative">
                <select class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline" bind:value={selectedFormulGosterge} required>
                  <option value="" disabled hidden>Seçiniz</option>
                  {#each gostergeler as gosterge}
                    {#if gosterge.deger_sayisi > 1}
                      <option value={gosterge._id}>{gosterge.name}</option>
                    {/if}
                  {/each}
                </select>
              </div>
              {#if $selectedGostergeDegerSayisi}
              <div class="mt-4">
                <p>Seçilen göstergenin Değişken Sayısı: {$selectedGostergeDegerSayisi}</p>
              </div>
            {/if}
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Formül
              </label>
              <input type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full" bind:value={formul} required readonly={!formulEditing} />
              <div class="mt-4 flex flex-wrap">
                <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul('+')}>+</button>
                <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul('-')}>-</button>
                <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul('*')}>*</button>
                <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul('/')}>/</button>
                <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul('(')}>(</button>
                <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul(')')}>)</button>
                <!-- {#each degiskenler as degisken, index}
                  {#if !clickedVariables[index]}
                    <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul(`{${degisken}}`, index)}>{degisken}</button>
                  {/if}
                {/each} -->

                {#each degiskenler as degisken, index}
                  <button type="button" class="bg-gray-200 text-gray-700 px-2 py-1 m-1 rounded" on:click={() => addToFormul(`{${degisken}}`)}>{degisken}</button>
                {/each}

              </div>
              <div class="mt-4 flex">
                <button type="button" class="bg-red-500 text-white px-2 py-1 m-1 rounded" on:click={undoFormul}>Geri Al</button>
                <button type="button" class="bg-yellow-500 text-white px-2 py-1 m-1 rounded" on:click={clearFormul}>Temizle</button>
              </div>
            </div>
          </div>
          <div class="w-full lg:w-6/12 px-4">
            <div class="relative w-full mb-3">
              <label class="block uppercase text-blueGray-600 text-xs font-bold mb-2" for="grid-password">
                Değişkenler
              </label>
              {#each Array($selectedGostergeDegerSayisi || 0) as _, index}
                <input type="text" class="border-0 px-3 py-3 placeholder-blueGray-300 text-blueGray-600 bg-white rounded text-sm shadow focus:outline-none focus:ring w-full mb-2" bind:value={degiskenler[index]} placeholder={`Değişken ${index + 1}`} required on:input={() => clickedVariables = new Array(degiskenler.length).fill(false)} />
              {/each}
            </div>
          </div>
        </div>
        <div class="flex items-center justify-end">
          <button class="bg-red-500 text-white active:bg-red-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="button" on:click={resetForm}>
            {formulEditing ? 'İptal' : 'Temizle'}
          </button>
          <button class="bg-emerald-500 text-white active:bg-blueGray-400 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 ease-linear transition-all duration-150" type="submit">
            {formulEditing ? 'Güncelle' : 'Ekle'}
          </button>
        </div>
      </div>
    </form>
  </div>
</div>
